var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-twitter-feed"},[_c('a',{staticClass:"twitter-timeline",attrs:{"data-widget-id":"265841979852718080","href":"https://twitter.com/AHAScience"}},[_vm._v("Tweets by @AHAScience")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d206a6f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/components/phd/twitter-feed.vue
// module id = 1345
// module chunks = 0